import React from 'react';

const BS_Buttons = () => {
    return (
        <div>
            <h1>BS_Buttons Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Buttons;
